import React, { useEffect } from "react";
import $ from "jquery";
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

function camelCaseToDisplayable(text) {
  let result = text.replace(/([A-Z])/g, " $1");
  let final = result.charAt(0).toUpperCase() + result.slice(1);
  return final;
}

function DataTable({ rows, columns, options, watch, scopes = {} }) {
  // Effects
  useEffect(() => {
    setTimeout(() => {
      $("#table-datatable").DataTable();
    }, 1000);
  }, [watch]);

  if (rows.length > 0)
    return (
      <table className="table bg-white" id="table-datatable">
        {columns ? (
          <thead className="table-head">
            <tr>
              {columns.map((column, key) => (
                <td key={key}>{camelCaseToDisplayable(column)}</td>
              ))}
              {options ? (
                <td>
                  <div className="d-flex justify-content-center align-items-center">
                    Actions
                  </div>
                </td>
              ) : null}
            </tr>
          </thead>
        ) : null}

        <tbody>
          {rows.map((row, key) => (
            <tr key={key}>
              {columns.map((column, key) => (
                <td key={key}>
                  {scopes[column] ? scopes[column](row[column]) : row[column]}
                </td>
              ))}
              {options ? (
                <td>
                  <div className="d-flex justify-content-center align-items-center">
                    {options(row, key)}
                  </div>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    );
  else
    return (
      <h4 className="text-primary text-center">
        There are no queries to show.
      </h4>
    );
}

export default DataTable;
